import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaWeatherIconComponent} from './la-weather-icon.component';
import {LaClearSkyComponent} from './icon-components/clear-sky/clear-sky.component';
import {LaFewCloudsComponent} from './icon-components/few-clouds/few-clouds.component';
import {LaMistComponent} from './icon-components/mist/mist.component';
import {LaRainComponent} from './icon-components/rain/rain.component';
import {LaScatteredCloudsComponent} from './icon-components/scattered-clouds/scattered-clouds.component';
import {LaShowerRainComponent} from './icon-components/shower-rain/shower-rain.component';
import {LaSnowComponent} from './icon-components/snow/snow.component';
import {LaThunderstormComponent} from './icon-components/thunderstorm/thunderstorm.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    LaWeatherIconComponent,
    LaClearSkyComponent,
    LaFewCloudsComponent,
    LaMistComponent,
    LaRainComponent,
    LaScatteredCloudsComponent,
    LaShowerRainComponent,
    LaSnowComponent,
    LaThunderstormComponent,
  ],
  exports: [
    LaWeatherIconComponent,
    LaClearSkyComponent,
    LaFewCloudsComponent,
    LaMistComponent,
    LaRainComponent,
    LaScatteredCloudsComponent,
    LaShowerRainComponent,
    LaSnowComponent,
    LaThunderstormComponent,
  ]
})
export class LaWeatherIconModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaWeatherIconModule,
      providers: []
    }
  }
}
